import * as React from "react";

import { Button, ControlGroup, H1, MenuItem } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";
import { css } from "glamor";
import { FilterItem } from "src/Interfaces";

const styles = {
	select: css({
		width: "300px !important",
		borderBottomLeftRadius: "3px !important",
		borderTopLeftRadius: "3px !important",
	}),
	resetFilter: css({ width: "40px" }),
	selectContainer: css({
		textAlign: "left",
		marginBottom: "10px",
	}),
	title: css({ textAlign: "left" }),
};

interface Props {
	items: FilterItem[];
	activeText: string;
	onItemSelect: (item: FilterItem) => void;
	resetFilter: () => void;
}

const itemRenderer = (item: FilterItem, { handleClick }: any) => {
	return (
		<MenuItem
			key={item.id + item.type}
			text={item.text}
			label={item.type}
			onClick={handleClick} // added this line
			// shouldDismissPopover={true}
		/>
	);
};
const itemPredicate = (query: string, item: FilterItem) => {
	const foundPattern = item.text.toLowerCase().includes(query.toLowerCase());
	return foundPattern;
};

const itemSort = (a: FilterItem, b: FilterItem) => {
	if (a.type !== b.type) {
		return 0;
	}
	if (a.text.toLowerCase() > b.text.toLowerCase()) {
		return 1;
	}
	return -1;
};
export default class FightPlanFilter extends React.Component<Props> {
	public state = {};

	public render() {
		return (
			<div>
				<H1 {...styles.title}>Filter Fightplan:</H1>
				<div {...styles.selectContainer}>
					<ControlGroup>
						<Select
							items={this.props.items.sort(itemSort)}
							itemRenderer={itemRenderer}
							noResults={<MenuItem disabled={true} text="No results." />}
							onItemSelect={this.props.onItemSelect}
							itemPredicate={itemPredicate}
						>
							{/* children become the popover target; render value here */}
							<Button
								{...styles.select}
								text={this.props.activeText}
								rightIcon="double-caret-vertical"
							/>
						</Select>
						<Button {...styles.resetFilter} rightIcon="cross" onClick={this.props.resetFilter} />
					</ControlGroup>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Public/FightPlanFilter.tsx